
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { EstadoMovDoProcesso } from '@app/models/estado-mov-do-processo.model';

@Injectable()
export class EstadoMovDoProcessoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  adicionar(estadoDoProcesso: EstadoMovDoProcesso): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'estadoMovDoProcesso', estadoDoProcesso).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  alterar(estadoDoProcesso: EstadoMovDoProcesso): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'estadoMovDoProcesso', estadoDoProcesso).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `estadoMovDoProcesso/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `estadoMovDoProcesso/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + 'estadoMovDoProcesso/');
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `estadoMovDoProcesso/pesquisar/?descricao=${descricao}&pagina=${pagina}`);
  }

}
